<div class="searchHeader">
  <div class="searchHeader-fixed">
    @if (mediumScreen) {
      <app-side-menu-toggle
        [sideMenuSmallScreen]="sideMenuSmallScreen"
        (filterSideMenuSmallScreenToggled)="toggleSideFilterMenuSmallScreen()"
        [searchContainer]="searchContainer"
      ></app-side-menu-toggle>
    }

    <div class="searchHeader__search-query">
      @if (searchContainer) {
        <app-search-query
          class="searchHeader__search-query__content"
          [searchContainer]="searchContainer"
          [placeholder]="searchPlaceholder"
          [setFocus]="setSearchQueryFocus"
          [newLayout]="newLayout"
          [noBorder]="true"
        ></app-search-query>
      }

      <div class="searchHeader__search-query__template-button-container">
        <div class="searchHeader__search-query__template-button-content">
          <app-template-group-select-button
            [disabled]="searchContainer.searching"
            [object]="searchContainer.object"
            [collapseOnSmallScreen]="true"
            [templateGroupId]="searchContainer.templateGroupId"
            (templateSelectorCreated)="onTemplateSelectorCreated($event)"
            (changeTemplateGroup)="onChangeTemplateGroup($event)"
          ></app-template-group-select-button>
        </div>
      </div>
    </div>
  </div>

  @if (isSearchViewSelectorEnabled()) {
    <app-search-view-selector
      [selectorContainer]="curSelectorContainer"
    ></app-search-view-selector>
  }

  @if(checkNewReportOpen()) {
    <new-report-sidemenu
      [searchContainer]="searchContainer"
    ></new-report-sidemenu>
  }
</div>

@if (isSearchViewSelectorEnabled()) {
  <div
    class="overlay"
    (click)="selectorOverlay()"
    (keydown)="null"
  ></div>
}
